import { useState } from 'react';
import PageHeader from '../../components/PageHeader';
import styles from './SupplierHelp.module.css';

const FAQS = [
  {
    id: 'FAQ-001',
    question: 'How do I place a supply order?',
    answer: 'Navigate to Orders in the sidebar, browse available products, add them to your cart, and click Place Order.',
  },
  {
    id: 'FAQ-002',
    question: 'What payment methods are available?',
    answer: 'Two modes: Cash on Delivery (full payment on receipt) and Consignment (payment after sales, commission deducted).',
  },
  {
    id: 'FAQ-003',
    question: 'How does the WFQ algorithm prioritize orders?',
    answer: 'Orders are weighted by demand, stock urgency, and order age. Higher-weight orders are processed first by the supplier.',
  },
  {
    id: 'FAQ-004',
    question: 'How do I track my delivery?',
    answer: 'Go to the Tracking module in the sidebar to see your order status and estimated arrival time.',
  },
  {
    id: 'FAQ-005',
    question: 'How do I report a system issue?',
    answer: 'Use the ticket system below to submit a ticket. The admin will be notified and respond as soon as possible.',
  },
];

export default function SupplierHelp() {
  const [openId, setOpenId] = useState(null);

  return (
    <div className={styles.page}>
      <PageHeader
        title="Help Center"
        description="Browse FAQs and track your support tickets"
      />

      <div className={styles.faqList}>
        {FAQS.map(faq => (
          <div key={faq.id} className={styles.faqItem}>
            <button
              className={styles.faqHeader}
              onClick={() => setOpenId(prev => prev === faq.id ? null : faq.id)}
              aria-expanded={openId === faq.id}
            >
              <span className={styles.faqQuestion}>{faq.question}</span>
              <span className={styles.faqChevron}>{openId === faq.id ? '▲' : '▼'}</span>
            </button>
            {openId === faq.id && (
              <div className={styles.faqBody}>
                <p className={styles.faqAnswer}>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}
